import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginSignupPanel } from 'src/pages/LoginSignup/LoginSignupPanel'
import { SignupSuccessPanel } from 'src/pages/SignupSuccess/SignupSuccessPanel'
import { Column } from 'src/shared/components/Semantic/all'
import { PageContainer } from 'src/shared/components/PageContainer'
import { Dialog, DialogContent, DialogTitle } from 'src/shared/components/ui/dialog'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const GuestSignupDialog = ({
  open,
  onOpenChange,
  initialEmail,
  initialLoginMode = false,
  nextPath,
  title,
  description,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialEmail: string
  initialLoginMode?: boolean
  nextPath: string
  title: string
  description: string
}) => {
  const { t } = useLocalization()
  const navigate = useNavigate()
  const [step, setStep] = useState<'login-signup' | 'signup-success'>(
    'login-signup'
  )
  const [orgId, setOrgId] = useState<string | null>(null)
  const [isLoginMode, setIsLoginMode] = useState(initialLoginMode)

  useEffect(() => {
    if (open) setIsLoginMode(initialLoginMode)
  }, [open, initialLoginMode])

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        onOpenChange(next)
        if (!next) {
          setStep('login-signup')
          setOrgId(null)
          setIsLoginMode(false)
        } else {
          setIsLoginMode(initialLoginMode)
        }
      }}
    >
      <DialogContent className="left-[50%] top-[50%] z-[200] flex h-[80vh] w-[80vw] max-h-[80vh] max-w-[80vw] translate-x-[-50%] translate-y-[-50%] flex-col gap-0 overflow-hidden rounded-xl border-0 p-0">
        <DialogTitle className="sr-only">
          {title || t('Save this quote', 'Spara den här offerten')}
        </DialogTitle>
        <Column className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden rounded-xl bg-background">
          {step === 'login-signup' ? (
            <PageContainer
              width="xl"
              className="min-h-0 flex-1 overflow-y-auto"
            >
              <LoginSignupPanel
                loginModeSource="controlled"
                isLoginMode={isLoginMode}
                onLoginModeChange={setIsLoginMode}
                initialEmail={initialEmail}
                nextPath={nextPath}
                signupTitle={title}
                signupDescription={description}
                onSignupOrgReady={(id) => {
                  setOrgId(id)
                  setStep('signup-success')
                }}
                className="h-full min-h-[min(100%,520px)]"
              />
            </PageContainer>
          ) : (
            <Column className="min-h-0 flex-1 overflow-hidden">
              <SignupSuccessPanel
                orgId={orgId}
                variant="embedded"
                onSuccess={() => navigate(nextPath)}
              />
            </Column>
          )}
        </Column>
      </DialogContent>
    </Dialog>
  )
}
